export default __webpack_public_path__ + "static/media/wTop_3.6a84eeff.bin";